/**
 * YouTube gömme adresi — TEK KAYNAK.
 *
 * `youtube-nocookie.com` kullanılıyor, `youtube.com` değil. İkisi de aynı
 * oynatıcıyı veriyor; fark, izleyici videoyu OYNATANA KADAR izleme çerezi
 * yazılmaması. Kullanıcılarımızın çoğu reşit değil ve sayfa açılır açılmaz
 * üçüncü taraf çerezi yazmak KVKK tarafında gereksiz bir yük.
 *
 * TELİF NOTU: gömme, videonun KOPYASINI ÇIKARMAZ — içerik YouTube'un
 * sunucusundan gelir, izlenme ve reklam geliri yayıncıya yazılır, yayıncı
 * istemiyorsa gömmeyi kapatabilir ve oynatıcı o zaman zaten çalışmaz.
 * Sınırın dışına çıkan şeyler: videoyu indirip kendi sunucumuzda sunmak,
 * kendi oynatıcımızı koymak, YouTube markasını gizlemek, reklamı atlatmak.
 * Bunların hiçbiri yapılmamalı.
 *
 * Adres ÜÇ AYRI EKRANDA kuruluyordu (soru çözümü, sınav takibi, yönetici
 * önizlemesi). Dördüncüsü eklenirse elle `youtube.com` yazılmasın diye tek
 * yere alındı; `server/__testler__/youtubeGomme.js` ham adres kalmadığını
 * denetliyor.
 */

/**
 * Gömme oynatıcısının adresi. Kimlik boşsa boş dizge döner.
 *
 * TS DEĞİL JS: `npm run lint` yalnızca .js/.jsx dosyalarına bakıyor ve
 * projedeki öteki paylaşılan yardımcılar da (topicKey.js, mufredatKaynagi.js)
 * böyle; ayrıca sunucu testleri dosyayı doğrudan okuyabiliyor.
 *
 * @param {string|null|undefined} videoId
 * @returns {string}
 */
export function youtubeGommeAdresi(videoId) {
    const kimlik = String(videoId || '').trim();
    if (!kimlik) return '';
    return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(kimlik)}`;
}
